import BusinessPartnerGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-group/business-partner-group.entity";
import { CommonModule } from "@angular/common";
import { Component, Inject, Optional, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatOptionModule } from "@angular/material/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import {
  MatSidenav,
  MatSidenavContainer,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ActivatedRoute, Router } from "@angular/router";
import { FuseFullscreenComponent } from "@fuse/components/fullscreen";
import { GeoManagerComponent } from "app/common/components/geo-manager/geo-manager.component";
import {
  MarkerData,
  MarkerGroup,
} from "app/common/components/geo-manager/geo-manager.interfaces";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { BusinessPartnersFiltersComponent } from "app/modules/components/filters/business-partners-filters/business-partners-filters.component";
import { DocumentsFiltersComponent } from "app/modules/components/filters/documents-filters/documents-filters.component";
import { RoutesFiltersComponent } from "app/modules/components/filters/routes-filters/routes-filters.component";
import { BusinessPartnerBySubRoute } from "app/modules/components/routing/sub-routes/interfaces/busines-partner-by-sub-route.interface";
import { MapModalViewModel } from "./map-modal.view-model";
import {
  MapFilterTypeEnum,
  MapModalTypeEnum,
  MonitorDocumentTypeEnum,
} from "./models/map-modal.enum";
import {
  ExtendsTrips,
  FilterVisitPayload,
  FrecuencyData,
  GroupData,
  MapModalInputData,
} from "./models/map-modal.interface";
import {
  buildMarkerFrecuencyGroups,
  buildMarkerGroups,
  buildMarkerSimple,
  buildMarkerSimpleTwo,
  buildMarkerVisitRoute,
  buildMarkerVisitTripGroups,
} from "./utils/map-marker.helper";
import { getGroupsList } from "./utils/map-modal.util";

@Component({
  selector: "app-map-modal",
  templateUrl: "./map-modal.component.html",
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule,
    MatSidenavContainer,
    MatSidenavModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    GeoManagerComponent,
    FuseFullscreenComponent,
    BusinessPartnersFiltersComponent,
    DocumentsFiltersComponent,
    RoutesFiltersComponent,
  ],
  standalone: true,
})
export class MapModalComponent {
  @ViewChild(GeoManagerComponent) geoManager!: GeoManagerComponent;
  @ViewChild("sidenav") sidenav: MatSidenav;

  form: FormGroup;
  isDataLoaded = false;
  isModal: boolean = false;

  allMarkerGroups: {
    groupId: string;
    groupName: string;
    markers: MarkerData[];
  }[] = [];
  filteredMarkerGroups: MarkerGroup[] = [];

  //info service
  dataOrderForMap: GroupData[] = [];
  dataFrecuencyForMap: FrecuencyData[] = [];
  useFrecuency: boolean = false;
  currentPage: number = 1;
  pageSizeLoan: number = 100;
  dataVisitTripRoute: ExtendsTrips[] = [];
  reasonVisits: string[] = [];
  allReasonVisits: string[] = [];

  //filter
  isInitialLoad = true;
  groupList: BusinessPartnerGroupAttributes[] = [];
  clientList: { _id: string; name: string }[] = [];
  private markerIdMap = new Map<string, string>();

  //type map
  mapModalTypeEnum = MapModalTypeEnum;
  monitorDocumentTypeEnum = MonitorDocumentTypeEnum;
  typeSimple: MapModalTypeEnum = MapModalTypeEnum.SIMPLE;

  constructor(
    private mapViewModel: MapModalViewModel,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    @Optional() public dialogRef: MatDialogRef<MapModalComponent>,
    @Inject(MAT_DIALOG_DATA) @Optional() public data: MapModalInputData
  ) {
    this.isModal = !!dialogRef;

    this.form = this.fb.group({
      businessPartnerGroupId: [],
      customerId: [],
      documentTypeId: [],
      subRouteId: [],
      routeTypeId: [],
      statusTripId: null,
      reasonVisitId: [],
      reasonVisit: null,
      frecuencyRoute: null,
    });
  }

  async ngOnInit() {
    if (!this.isModal && !this.data) {
      const viewerId = this.route.snapshot.queryParamMap.get("viewerId");
      if (viewerId) {
        const savedData = sessionStorage.getItem(`geoViewerData-${viewerId}`);
        if (savedData) {
          this.data = JSON.parse(savedData);
        }
      }
    }

    this.typeSimple = this.data.type;
    if (
      this.typeSimple === MapModalTypeEnum.GROUPED_WITH_FILTER ||
      this.typeSimple === MapModalTypeEnum.GROUPED_WITHOUT_FILTER
    ) {
      await this.loadDataOrderMap(this.data.document);
      this.initMapFilter();
    }

    if (this.typeSimple === MapModalTypeEnum.FRECUENCY_ROUTE) {
      await this.loadDataFrecuencyRouteMap();
    }

    if (this.typeSimple === MapModalTypeEnum.FRECUENCY_DATE_ROUTE) {
      this.initFrecuencyDateRoute();
    }

    if (this.typeSimple === MapModalTypeEnum.VISIT_ROUTE_GLOBAL_FILTER) {
      await this.loadDataVisitsTrip({});
      this.initMapTripVisit();
    }
  }

  async ngAfterViewInit() {
    if (
      this.typeSimple == MapModalTypeEnum.SIMPLE ||
      this.typeSimple == MapModalTypeEnum.SIMPLE_TWO ||
      this.typeSimple == MapModalTypeEnum.VISIT_ROUTE
    ) {
      this.initMap();
    }
  }

  //#region INFO
  async loadDataOrderMap(
    documentType?: string,
    documentIds?: string[],
    filters: { groupIds: string[]; shipTo: string[] } = {
      groupIds: [],
      shipTo: [],
    }
  ) {
    //if (!this.data.tripId) return;

    try {
      const sortField =
        documentType === MonitorDocumentTypeEnum.VISIT
          ? "dateTimeStart"
          : "createdAt";
      const tripId = this.data.tripId;

      let data;

      if (documentType === MonitorDocumentTypeEnum.VISIT) {
        // Llamar al servicio de VISIT
        data = await this.mapViewModel.getGroupTripShipTo(
          this.pageSizeLoan,
          this.currentPage,
          sortField,
          tripId,
          filters
        );
      } else {
        // Llamar al servicio normal de documentos
        const documents = documentIds?.length
          ? documentIds
          : documentType === MonitorDocumentTypeEnum.DOCUMENT
            ? [DocumentTypeEnum.DOCUMENTO_DE_CARGA]
            : documentType === MonitorDocumentTypeEnum.DELIVERY
              ? [DocumentTypeEnum.ENTREGA_SALIDA]
              : documentType === MonitorDocumentTypeEnum.PROGRESS
                ? this.data.groupDocuments || []
                : [];

        const isExtraFilter =
          this.data.filters?.mode ===
            MapFilterTypeEnum.EXTRA_UNATTENDED_ORDERS ||
          this.data.filters?.mode === MapFilterTypeEnum.EXTRA_WITHOUT_TRIP;
        const extraFilters = this.data.filters?.filters ?? {};
        const mergedFilters = {
          ...filters,
          ...extraFilters,
        };

        data = isExtraFilter
          ? await this.mapViewModel.getGroupOrderShipToWithExtraFilters(
              this.pageSizeLoan,
              this.currentPage,
              sortField,
              null,
              documents,
              {
                mode: this.data.filters?.mode,
                filters: mergedFilters,
              }
            )
          : await this.mapViewModel.getGroupOrderShipTo(
              this.pageSizeLoan,
              this.currentPage,
              sortField,
              this.data.tripId,
              documents,
              mergedFilters
            );
      }

      this.dataOrderForMap = data || [];
    } catch (error) {
      this.snackBar.open(
        error.error?.message || "Error al obtener data",
        "Cerrar",
        { duration: 3000 }
      );
    }
  }

  async loadDataFrecuencyRouteMap(
    filters: { groupIds: string[]; shipTo: string[] } = {
      groupIds: [],
      shipTo: [],
    }
  ) {
    this.useFrecuency = this.data.element?.type == "U" ? false : true;
    try {
      const sortField = "createdAt";
      const subRouteId = this.data.element._id;

      let data = await this.mapViewModel.getGroupRoute(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        subRouteId,
        this.data.element?.type == "U" ? false : true,
        filters
      );

      this.dataFrecuencyForMap = this.buildFrecuencyData(data || []);
      this.getInfoFrecuency();
    } catch (error) {
      this.snackBar.open(
        error.error?.message || "Error al obtener data",
        "Cerrar",
        { duration: 3000 }
      );
    }
  }

  async fetchBusinessbyFrequency(): Promise<void> {
    if (this.data.element.modeWeekDays) {
      const mapped = await this.mapViewModel.fetchBusinessbyWeekDay(
        this.data.element._id,
        this.form.value.frecuencyRoute
      );
      this.dataFrecuencyForMap = mapped;
      this.getInfoFrecuency();
      this.updateClientList();
    } else {
      if (!this.form.value.frecuencyRoute?._id) {
        return;
      }
      this.mapViewModel.fetchBusinessbyFrequency(
        this.data.element._id,
        this.form.value.frecuencyRoute,
        (mapped) => {
          this.dataFrecuencyForMap = mapped;
          this.getInfoFrecuency();
          this.updateClientList();
        }
      );
    }
  }

  private buildFrecuencyData(
    data: BusinessPartnerBySubRoute[]
  ): FrecuencyData[] {
    const map = new Map<string, FrecuencyData>();

    for (const item of data) {
      const group = item.businessPartnerGroup;
      if (!group) {
        continue; // si no tiene grupo, lo saltamos
      }

      const groupId = String(group._id);
      if (!map.has(groupId)) {
        map.set(groupId, { group, shipTo: [] });
      }
      map.get(groupId)!.shipTo.push(item);
    }
    return Array.from(map.values());
  }

  getInfoFrecuency() {
    this.allMarkerGroups = buildMarkerFrecuencyGroups(
      this.dataFrecuencyForMap
    ).map((g) => {
      const originalGroup = this.dataFrecuencyForMap.find(
        (grp) => grp.group.name === g.groupName
      );
      return {
        groupId: String(originalGroup?.group._id) || null,
        groupName: g.groupName,
        markers: g.markers,
      };
    });

    this.filteredMarkerGroups = this.allMarkerGroups.map((g) => ({
      groupName: g.groupName,
      markers: g.markers,
    }));

    if (this.isInitialLoad) {
      this.groupList = getGroupsList(
        this.dataFrecuencyForMap,
        (shipTo) => shipTo?.principalAddress?.geolocationPoint
      );
      this.isInitialLoad = false;
    }
    this.getMarkerIdMap(this.dataFrecuencyForMap);
    this.isDataLoaded = true;
  }

  async loadDataVisitsTrip(filter?: FilterVisitPayload) {
    const { trips, visitNames } =
      await this.mapViewModel.findAllTripGlobal(filter);
    this.dataVisitTripRoute = trips;
    if (!filter || Object.keys(filter).length === 0) {
      this.reasonVisits = visitNames;
      this.allReasonVisits = visitNames;
    } else {
      this.reasonVisits = this.allReasonVisits;
    }
  }
  //#endregion

  //#region Mapa Basic
  initMap() {
    switch (this.typeSimple) {
      case MapModalTypeEnum.SIMPLE:
        this.filteredMarkerGroups = buildMarkerSimple(this.data.element);
        break;
      case MapModalTypeEnum.SIMPLE_TWO:
        this.filteredMarkerGroups = buildMarkerSimpleTwo(this.data.element);
        break;
      case MapModalTypeEnum.VISIT_ROUTE:
        this.filteredMarkerGroups = buildMarkerVisitRoute(
          this.data.element,
          false
        );
        break;
    }
    this.isDataLoaded = true;
  }

  onToggleChange(values: string[]): void {
    const selected = values.includes("location-ave");
    this.filteredMarkerGroups = buildMarkerVisitRoute(
      this.data.element,
      selected
    );
    this.reloadMap(this.filteredMarkerGroups);
  }
  //#endregion

  //#region Mapa Filter
  initMapFilter() {
    this.allMarkerGroups = buildMarkerGroups(
      this.dataOrderForMap,
      this.data.document,
      this.data.useDate
    ).map((g, i) => {
      const originalGroup = this.dataOrderForMap.find(
        (grp) => grp.group.name === g.groupName
      );
      return {
        groupId: String(originalGroup?.group._id) || null,
        groupName: g.groupName,
        markers: g.markers,
      };
    });

    // Guardar los marcadores filtrados para el mapa
    this.filteredMarkerGroups = this.allMarkerGroups.map((g) => ({
      groupName: g.groupName,
      markers: g.markers,
    }));

    if (this.isInitialLoad) {
      this.groupList = getGroupsList(
        this.dataOrderForMap,
        (shipTo) => shipTo?.addresses?.[0]?.geolocationPoint
      );
      this.isInitialLoad = false;
    }
    this.getMarkerIdMap(this.dataOrderForMap);
    this.isDataLoaded = true;
  }

  async initFrecuencyDateRoute() {
    if (this.data.element.modeWeekDays) {
      this.fetchBusinessbyFrequency();
      this.useFrecuency = true;
    } else {
      this.filteredMarkerGroups = [];
      this.useFrecuency = true;
      this.isDataLoaded = true;
    }
  }

  getMarkerIdMap(data) {
    this.markerIdMap.clear();
    data.forEach((group) => {
      (group.shipTo || []).forEach((shipTo) => {
        const title = shipTo.commercialName || shipTo.name || "" || "-";
        const _id = shipTo._id;
        this.markerIdMap.set(title, String(_id));
      });
    });
  }

  updateClientList() {
    const selectedGroups = this.form.value.businessPartnerGroupId;
    const frecuencyPartners =
      this.form.value.frecuencyRoute?.businessPartners || [];

    // Si no hay grupo seleccionado, mostrar clientes de todos los grupos
    let markers = this.allMarkerGroups.flatMap((g) => g.markers);

    // Si hay grupo seleccionado, filtrar solo esos
    if (Array.isArray(selectedGroups) && selectedGroups.length > 0) {
      markers = this.allMarkerGroups
        .filter((g) => selectedGroups.includes(g.groupId))
        .flatMap((g) => g.markers);
    }

    // Filtrar por frecuencia si corresponde
    const frecuencyIds = new Set(
      frecuencyPartners.map((bp) => bp.businessPartner._id)
    );
    if (frecuencyIds.size > 0) {
      markers = markers.filter((m) =>
        frecuencyIds.has(this.markerIdMap.get(m.title) || m.title)
      );
    }

    // Crear lista única de clientes
    const seen = new Set<string>();
    this.clientList = markers
      .map((m) => ({
        _id: this.markerIdMap.get(m.title) || m.title,
        name: m.title,
      }))
      .filter((c) => {
        if (seen.has(c._id)) return false;
        seen.add(c._id);
        return true;
      });
  }

  initMapTripVisit() {
    this.filteredMarkerGroups = buildMarkerVisitTripGroups(
      this.dataVisitTripRoute
    );
    this.isDataLoaded = true;
    if (this.geoManager) {
      this.reloadMap(this.filteredMarkerGroups);
    }
  }

  async applyFilters() {
    this.isDataLoaded = false;
    if (this.typeSimple === MapModalTypeEnum.VISIT_ROUTE_GLOBAL_FILTER) {
      const filter: FilterVisitPayload = {
        subRouteType: this.form.value.routeTypeId,
        subRouteId: this.form.value.subRouteId,
        statusTripId: this.form.value.statusTripId,
        reasonVisit: this.form.value.reasonVisit,
      };
      await this.loadDataVisitsTrip(filter);
      this.initMapTripVisit();
    } else {
      const selectedGroups = this.form.value.businessPartnerGroupId;
      const selectedClients = this.form.value.customerId;
      const selectedDocuments = this.form.value.documentTypeId;

      const filters = {
        groupIds: selectedGroups,
        shipTo: selectedClients,
      };

      if (
        this.typeSimple === MapModalTypeEnum.FRECUENCY_ROUTE ||
        this.typeSimple === MapModalTypeEnum.FRECUENCY_DATE_ROUTE
      ) {
        this.filterMarkersFrecuency(selectedGroups, selectedClients, false);
      } else {
        this.loadDataOrderMap(
          this.data.document,
          selectedDocuments?.length > 0 ? selectedDocuments : [], // documentos solo si hay
          filters
        ).then(() => {
          if (this.typeSimple === MapModalTypeEnum.GROUPED_WITH_FILTER) {
            this.initMapFilter();
            this.filterMarkers(selectedGroups, selectedClients, true);
          } else {
            this.filterMarkers(selectedGroups, selectedClients);
          }
        });
      }
    }

    this.sidenav.close();
  }

  filterMarkers(
    selectedGroups: String[],
    selectedClients: string[],
    skipGroupClientFilters: boolean = false
  ) {
    const selectedReasons = this.form.value.reasonVisitId;
    let filteredData = [...this.dataOrderForMap];

    if (!skipGroupClientFilters) {
      // 1. Filtrar por grupos
      if (Array.isArray(selectedGroups) && selectedGroups.length > 0) {
        filteredData = filteredData.filter((g) =>
          selectedGroups.includes(String(g.group._id))
        );
      }

      // 2. Filtrar por clientes
      if (Array.isArray(selectedClients) && selectedClients.length > 0) {
        filteredData = filteredData
          .map((g) => ({
            ...g,
            shipTo: (g.shipTo || []).filter((ship) =>
              selectedClients.includes(String(ship._id))
            ),
          }))
          .filter((g) => g.shipTo.length > 0);
      }
    }

    // 3. Filtrar por motivo de visita
    if (Array.isArray(selectedReasons) && selectedReasons.length > 0) {
      filteredData = filteredData
        .map((g) => ({
          ...g,
          shipTo: g.shipTo
            .map((ship) => ({
              ...ship,
              visits: (ship.visits || []).filter((v) =>
                selectedReasons.includes(v.reasonForVisit?.id)
              ),
            }))
            .filter((ship) => ship.visits.length > 0),
        }))
        .filter((g) => g.shipTo.length > 0);
    }

    // 4. Reconstruir markers con los datos filtrados
    this.allMarkerGroups = buildMarkerGroups(
      filteredData,
      this.data.document,
      this.data.useDate
    ).map((g) => ({
      groupId:
        String(
          filteredData.find((grp) => grp.group.name === g.groupName)?.group._id
        ) || null,
      groupName: g.groupName,
      markers: g.markers,
    }));

    this.getMarkerFilter();
  }

  filterMarkersFrecuency(
    selectedGroups: String[],
    selectedClients: number[],
    skipGroupClientFilters: boolean = false
  ) {
    const frecuencyPartners =
      this.form.value.frecuencyRoute?.businessPartners || [];
    let filteredData = [...this.dataFrecuencyForMap];
    if (!skipGroupClientFilters) {
      // 1. Filtrar por grupos
      if (Array.isArray(selectedGroups) && selectedGroups.length > 0) {
        filteredData = filteredData.filter((g) =>
          selectedGroups.includes(String(g.group._id))
        );
      }

      // 2. Filtrar por clientes
      if (
        (Array.isArray(selectedClients) && selectedClients.length > 0) ||
        frecuencyPartners.length > 0
      ) {
        const frecuencyIds = new Set(
          frecuencyPartners.map((bp) => bp.businessPartner.id)
        );
        filteredData = filteredData
          .map((g) => ({
            ...g,
            shipTo: (g.shipTo || []).filter((ship) => {
              const byClient =
                Array.isArray(selectedClients) && selectedClients.length > 0
                  ? selectedClients.includes(ship.id)
                  : true;
              const byFrecuency = frecuencyIds.size
                ? frecuencyIds.has(ship.id)
                : true;
              return byClient && byFrecuency;
            }),
          }))
          .filter((g) => g.shipTo.length > 0);
      }
    }

    // 4. Reconstruir markers con los datos filtrados
    this.allMarkerGroups = buildMarkerFrecuencyGroups(filteredData).map(
      (g) => ({
        groupId:
          String(
            filteredData.find((grp) => grp.group.name === g.groupName)?.group
              ._id
          ) || null,
        groupName: g.groupName,
        markers: g.markers,
      })
    );
    this.getMarkerFilter();
  }

  private getMarkerFilter() {
    this.filteredMarkerGroups = this.allMarkerGroups.map((g) => ({
      groupName: g.groupName,
      markers: g.markers,
    }));

    this.isDataLoaded = true;
    if (this.geoManager) {
      this.reloadMap(this.filteredMarkerGroups);
    }
  }

  private reloadMap(markerGroups: MarkerGroup[]) {
    // Destruir mapa actual
    if (this.geoManager.map) {
      this.geoManager.map.remove();
    }

    // Actualizar marcadores y reinicializar
    this.geoManager.markerGroups = markerGroups;
    this.geoManager.reloadMap();
  }

  clearFilters() {
    this.form.reset();
    this.applyFilters();
  }
  //#endregion

  //#region Window
  openInNewWindow(): void {
    // Generar ID único simple
    const viewerId = `viewer-${Date.now()}-${Math.floor(Math.random() * 10000)}`;

    // Guardar la data en sessionStorage con ID
    sessionStorage.setItem(
      `geoViewerData-${viewerId}`,
      JSON.stringify(this.data)
    );

    const fullUrl = `${window.location.origin}/geo-viewer?viewerId=${viewerId}`;
    //const newWindow = window.open(`/geo-viewer?viewerId=${viewerId}`, 'geo-viewer', windowFeatures);
    const newWindow = window.open(fullUrl, "_blank");

    if (!newWindow) {
      alert("Por favor permite popups para abrir en nueva ventana");
    }
  }
  //#endregion
}
